import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminUnlockedState, ADMIN_UNLOCK_KEY } from '../hooks/useAdminUnlocked';

/**
 * AdminGuard — wraps admin-only routes. Access is granted when the local
 * passcode gate is unlocked (More page) OR the visitor is a signed-in
 * admin (Jun-2026: the phone / installed PWA never had the localStorage
 * flag, so admin pages were unreachable there).
 *
 * The actual admin backend endpoints remain protected server-side by
 * `require_admin`. This guard is a UX layer only.
 */
export { ADMIN_UNLOCK_KEY };

const AdminGuard = ({ children }) => {
  const location = useLocation();
  const { unlocked, loading } = useAdminUnlockedState();
  if (loading) return null;
  if (!unlocked) {
    // Send them to /more with a `?unlock=1` hint so the MorePage can
    // auto-open the passcode modal for them.
    return <Navigate to={`/more?unlock=1&from=${encodeURIComponent(location.pathname)}`} replace />;
  }
  return children;
};

export default AdminGuard;
